export const alumColor = [
  {
    id: 1,
    type: "aluminumColor",
    label: "Jet Black",
  },
  {
    id: 2,
    type: "aluminumColor",
    label: "Espresso Brown",
  },
  {
    id: 3,
    type: "aluminumColor",
    label: "Sandcastle Tan",
  },
  {
    id: 4,
    type: "aluminumColor",
    label: "Linen White",
  },
  {
    id: 5,
    type: "aluminumColor",
    label: "Clear Anodized",
  },
  {
    id: 6,
    type: "aluminumColor",
    label: "Custom Color (upcharge applies)",
  },
];
